// NOTHING is imported at module scope here on purpose.
//
// `firebase/analytics` pulls in @firebase/installations, which bundles a copy
// of idb that reads IDBIndex, IDBCursor and friends as bare globals while the
// module is still evaluating. Where IndexedDB is absent - iOS private
// browsing, and Edge/Safari on iOS with strict tracking prevention - that is a
// ReferenceError during import, which takes down the entire bundle before React
// mounts anything. The result is a white page with no explanation.
//
// firebaseInit() was already only called in production, but an import runs
// regardless of who calls what, so the guard never had a chance. Loading these
// dynamically keeps the failure contained to analytics, where it belongs.

const config = {
  apiKey: "AIzaSyDnoL_A9pvT5RGeQ1xNHMLCUNgjh1U18zU",
  authDomain: "audio-237812.firebaseapp.com",
  databaseURL: "https://audio-237812.firebaseio.com",
  projectId: "audio-237812",
  storageBucket: "audio-237812.appspot.com",
  messagingSenderId: "755034602295",
  appId: '1:755034602295:web:f2ce65c1ca1f576566f8b2',
  measurementId: 'G-4EW2WK9P1M',
};

/**
 * Analytics is optional. Never let it break startup.
 */
export default async function firebaseInit() {
  try {
    const appModule = await import('firebase/app');
    const firebase = appModule.default || appModule;

    firebase.initializeApp(config);

    // Analytics requires IndexedDB (via @firebase/installations). Importing it
    // where IndexedDB is missing throws, so do not even reach for it.
    if (!('indexedDB' in window) || !window.indexedDB) {
      console.warn('Skipping Firebase analytics: IndexedDB unavailable');
      return;
    }

    await import('firebase/analytics');
    firebase.analytics();
  }
  catch (err) {
    // Analytics is not worth a broken app.
    console.error('Firebase initialisation failed, continuing without it', err);
  }
}
